import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute.jsx';
import { getSubscriptionStatus } from '../payments.js';

const Dashboard = () => {
  const subscriptionStatus = getSubscriptionStatus();

  return (
    <ProtectedRoute requireSubscription={true}>
      <div className="dashboard-page">
        <div className="container">
          <h1>Dashboard</h1>
          
          <div className="welcome-section">
            <h2>Welcome to AI Tools!</h2>
            <p>You have access to all our AI-powered tools.</p>
            
            {subscriptionStatus && (
              <div className="subscription-summary">
                <h3>Subscription Status</h3>
                <div className="status-cards">
                  <div className="status-card">
                    <span className="status-label">Plan</span>
                    <span className="status-value">{subscriptionStatus.plan}</span>
                  </div>
                  <div className="status-card">
                    <span className="status-label">Status</span>
                    <span className={`status-value ${subscriptionStatus.active ? 'active' : 'inactive'}`}>
                      {subscriptionStatus.active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  <div className="status-card">
                    <span className="status-label">Access</span>
                    <span className={`status-value ${subscriptionStatus.notExpired ? 'valid' : 'expired'}`}>
                      {subscriptionStatus.notExpired ? 'Valid' : 'Expired'}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="tools-section">
            <h3>Available AI Tools</h3>
            <div className="tools-grid">
              <div className="tool-card">
                <h4>Content Generation</h4>
                <p>Generate blog posts, articles, and creative content</p>
                <a href="/tools/content" className="btn btn-primary">Use Tool</a>
              </div>
              
              <div className="tool-card">
                <h4>Code Assistant</h4>
                <p>Get help with coding and debugging</p>
                <a href="/tools/code" className="btn btn-primary">Use Tool</a>
              </div>
              
              <div className="tool-card">
                <h4>Data Analysis</h4>
                <p>Analyze and visualize your data</p>
                <a href="/tools/data" className="btn btn-primary">Use Tool</a>
              </div>
              
              <div className="tool-card">
                <h4>Creative Writing</h4>
                <p>Generate stories, poems, and creative text</p>
                <a href="/tools/creative" className="btn btn-primary">Use Tool</a>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h3>Quick Actions</h3>
            <div className="action-buttons">
              <a href="/account" className="btn btn-outline">Manage Subscription</a>
              <a href="/tools" className="btn btn-primary">Browse All Tools</a>
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default Dashboard;
